import axios from "utils/axios";
import type { CustomAxiosRequestConfig } from "@xt/xtbase";

const URL = "/sapi/v4/balance/";

//获取币种列表
export function get_currencies(config?: CustomAxiosRequestConfig) {
  return axios.get(URL + `public/currencies`, config);
}

//获取所有币种折算价格
export function get_priceCurrencyConvert(config?: CustomAxiosRequestConfig) {
  return axios.get(URL + `public/price/currency/convert`, config);
}

//获取币种介绍列表
export function get_currencyInfoOne(currency: string, config?: CustomAxiosRequestConfig) {
  return axios.get(URL + `public/currency-info/${currency}`, config);
}

// 获取资产列表
export function get_balances(config?: CustomAxiosRequestConfig) {
  return axios.get(URL + `balances`, config);
}
// 获取单个资产
export function get_balance(config) {
  return axios.get(URL + `balance`, config);
}

// 获取杠杆单个资产
export function get_leverBalance(config?: CustomAxiosRequestConfig) {
  return axios.get(URL + `lever/balance`, config);
}

// 获取杠杆市场资产
export function get_leverBalances(config?: CustomAxiosRequestConfig) {
  return axios.get(URL + `lever/balances`, config);
}

// 获取总资产和各个业务账号资产，现货/杠杆/合约/理财
export function get_balanceTotal(config?: CustomAxiosRequestConfig) {
  return axios.get(URL + `balance/total`, config);
}

// 获取带ai跟单的总资产
export function get_balanceTotalWithAiFollow(config) {
  return axios.get(URL + `balance/total/with-ai-follow`, config);
}


// 获取账单列表
export function get_bills(config?) {
  return axios.get(URL + `balance/bills`, config);
}

//获取币种关联转账网络信息
export function get_currencyId(id, config?: CustomAxiosRequestConfig) {
  return axios.get(URL + `public/currency/${id}`, config);
}

// 获取理财资产
export function get_financeBalance(config?: CustomAxiosRequestConfig) {
  return axios.get(URL + `finance/balance`, config);
}

// 获取理财持仓
export function get_financePosition(config?: CustomAxiosRequestConfig) {
  return axios.get(URL + `finance/position`, config);
}

// 获取ntf 提现列表
export function get_nftPosition(config?: CustomAxiosRequestConfig) {
  return axios.get(URL + `nft/position`, config);
}
